const storeActions = {
    // Content Actions
    GET_PAGE_DATA: "getPageData",
    SAVE_PAGE_DATA: "savePageData",

    // Vehicle Actions
    GET_VEHICLE_YEARS: "getVehicleYears",
    GET_VEHICLE_MAKES: "getVehicleMakes",
    GET_VEHICLE_MODELS: "getVehicleModels",
    GET_VEHICLE_STYLES: "getVehicleStyles",
    GET_VEHICLE: "getVehicle",
    GET_DAMAGE_OPTIONS: "getDamageOptions",
    GET_EVOX_IMAGE: "getEvoxImage",
    IS_VIN_OPTIONAL_VEHICLE: "isVinOptionalVehicle",
    IS_VIN_BY_ADDRESS_PERMISSIBLE: "isVinByAddressPermissible",

    // Lookup Actions
    LOOKUP_VEHICLE_BY_YMMS: "lookupVehicleByYmms",
    LOOKUP_VEHICLE_BY_VIN: "lookupVehicleByVin",
    LOOKUP_VIN_BY_PLATE: "lookupVinByPlate",
    LOOKUP_VIN_BY_ADDRESS: "lookupVinByAddress",
    LOOKUP_VIN_BY_IMAGE: "lookupVinByImage",
    GET_ALERT_REASONS_BY_CTU: "getAlertReasonsByCtu",
    GET_PARTS_OR_QUESTIONS: "getPartsOrQuestions",
    GET_PARTS: "getParts",
    GET_OEM_AFTERMARKET_PARTS: "getOemAfterMarketParts",
    GET_WIPERS: "getWipers",
    GET_RAIN_REPEL: "getRainRepel",
    GET_SUPPORTING_ITEMS: "getSupportingItems",
    GET_CAPABILITY_QUESTIONS: "getCapabilityQuestions",
    SUBMIT_DONATION_PART_TO_SV2: "submitDonationPartToSV2",
    GET_PART_FROM_CAPABILITY_QUESTION_ANSWER: "getPartFromCapabilityQuestionAnswer",
    GET_MOLDING_QUESTIONS: "getMoldingQuestions",
    GET_MOBILE_FEE_PART: "getMobileFeePart",
    GET_PRICING_BY_DAY_PART: "getPricingByDayPart",
    GET_SERVICEABILITY_DETAILS: "getServiceabilityDetails",
    GET_SHOP_TIME_SLOTS: "getShopTimeSlots",
    GET_SHOP_TIME_SLOTS_V2: "getShopTimeSlotsV2",
    GET_MOBILE_TIME_SLOTS: "getMobileTimeSlots",
    GET_MOBILE_TIME_SLOTS_V2: "getMobileTimeSlotsV2",
    GET_PROVIDERS: "getProviders",
    GET_MOBILE_PREMIUM_FEE: "getMobilePremiumFee",
    SAVE_SESSION: "saveSession",
    LOAD_SESSION: "loadSession",
    SAVE_QUOTE: "saveQuote",
    UPDATE_STORE_WITH_SAVE_SESSION_RESPONSE: "updateStoreWithSaveSessionResponse",
    VALIDATE_ZIP: "validateZip",
    PRICE_ORDER_ITEMS_AND_SAVE_SERVER_DATA: "priceOrderItemsAndSaveServerData",
    TAX_ORDER_ITEMS_AND_SAVE_SERVER_DATA: "taxOrderItemsAndSaveServerData",
    GET_EXPERIMENTS_BY_USER: "GetExperimentsByUser",
    RUN_EXPERIMENTS_FOR_TRIGGER: "runExperimentsForTrigger",
    FORCE_EXPERIMENTS: "forceExperiments",
    CLEAR_VIN: "clearVin",
    RESET_SAVE_SESSION_PROMISE: "resetSaveSessionPromise",
    GET_SIGNATURE: "getSignature",
    VALIDATE_ORDER_PROMO_AND_SAVE_SERVER_DATA: "validateOrderPromoAndSaveServerData",
    REVALIDATE_ORDER_PROMOS_AND_SAVE_SERVER_DATA: "revalidateOrderPromosAndSaveServerData",
    GET_INSURANCE_COMPANY_LIST: "getInsuranceCompanyList",
    GET_BILL_TO_ACCOUNT_NUMBER: "getBillToAccountNumber",
    GET_ACCOUNT_DETAILS: "getAccountDetails",
    GET_RECAL_PARTS_AND_SAVE_TO_LINE_ITEMS: "getRecalPartsAndSaveToLineItems",
    GET_CLOSEST_APPLICABLE_SHOPS: "getClosestApplicableShops",
    GET_DUPLICATE_REFERRALS: "getDuplicateReferrals",
    GET_POLICY_INFORMATION: "getPolicyInformation",
    SAVE_POLICY_INFORMATION: "savePolicyInformation",
    SAVE_POLICY_DATA: "savePolicyData",
    SAVE_POLICY_VEHICLE_ID: "savePolicyVehicleId",
    SAVE_MATCHED_POLICY_VEHICLE: "saveMatchedPolicyVehicle",
    SAVE_UNMATCHED_POLICY_VEHICLE: "saveUnmatchedPolicyVehicle",
    SAVE_VEHICLE_CHANGED_DURING_POLICY_LOOKUP: "saveVehicleChangedDuringPolicyLookup",
    GET_FINAL_DEDUCTIBLE: "getFinalDeductible",
    SET_DEDUCTIBLE: "setDeductible",
    GET_ITAC_PRICING: "getItacPricing",
    APPLY_ITAC_PRICING_RESULT: "applyItacPricingResult",
    REGISTER_CLAIM: "registerClaim",
    SAVE_COVERAGE_RESULT: "saveCoverageResult",
    SAVE_CLAIM_REGISTRATION_RESULT: "saveClaimRegistrationResult",
    SAVE_ENDORSEMENT_ANSWERS: "saveEndorsementAnswers",

    // Analytics
    LOG_EXPERIMENT_EXPOSURE_AND_UPDATE_STORE: "logExperimentExposureAndUpdateStore",
    LOG_PAGE_VIEW: "logPageView",
    LOG_CUSTOM_EVENT: "logCustomEvent",
    INITIALIZE_SESSION: "initializeSession",
    LOG_PART_QUESTIONS: "logPartQuestions",
    LOG_FMG_SESSION_DATA: "logFmgSessionData",

    // DEPENDENCY MUTATIONS
    RESET_VEHICLE_STATE_AND_DEPENDENCIES: "resetVehicleStateAndDependencies",
    RESET_DAMAGE_STATE_AND_DEPENDENCIES: "resetDamageAndDependencies",
    RESET_REGISTRATION_STATE_AND_DEPENDENCIES: "resetRegistrationAndDependencies",
    RESET_PARTS_STATE_AND_DEPENDENCIES: "resetPartsAndDependencies",
    RESET_SERVICE_LOCATION_STATE_AND_DEPENDENCIES: "resetServiceLocationAndDependencies",
    RESET_STATE: "resetState",

    // SAVE COMPONENT STATE
    SAVE_VEHICLE: "saveVehicle",
    SAVE_VEHICLE_DAMAGE: "saveVehicleDamage",
    SAVE_VIN_LOOKUP: "saveVinLookup",
    SAVE_SERVICE_ZIP_CODE_INFO: "saveServiceZipCodeInfo",
    SAVE_SERVICE_LOCATION: "saveServiceLocation",
    SAVE_MOBILE_DETAILS: "saveMobileDetails",
    SAVE_SCHEDULE: "saveSchedule",
    SAVE_EMAIL: "saveEmail",
    SAVE_PHONE_NUMBER: "savePhoneNumber",
    SAVE_IS_SMS_OPT_IN: "saveIsSmsOptIn",
    SAVE_IS_SMS_MARKETING_OPT_IN: "saveIsSmsMarketingOptIn",
    SAVE_WAITLIST_REQUESTED: "saveWaitListRequested",
    SAVE_REGISTRATION_LICENSE_PLATE_LOOKUP: "saveRegistrationLicensePlateLookup",
    SAVE_VIN: "saveVin",
    SAVE_REGISTRATION_ADDRESS_LOOKUP: "saveRegistrationAddressLookup",
    SAVE_GLASS_PARTS: "saveGlassParts",
    SAVE_GLASS_PARTS_SUPPRESSING_STATE_RESETTING: "saveGlassPartsSuppressingStateResetting",
    SAVE_PART_QUESTION_ANSWERS: "savePartQuestionAnswers",
    RESET_MOLDING_AND_CAPABILITY_QUESTIONS_IF_NEEDED:
        "resetMoldingAndCapabilityQuestionAnswersIfNeeded",
    SAVE_MOLDING_QUESTION_ANSWERS: "saveMoldingQuestionAnswers",
    SAVE_CAPABILITY_QUESTION_ANSWERS: "saveCapabilityQuestionAnswers",
    SAVE_PAYMENT_TYPE: "savePaymentType",
    SAVE_PAYMENT_METHOD_CHOICE: "savePaymentMethodChoice",
    SAVE_PARENT_ACCOUNT_NUMBER: "saveParentAccountNumber",
    SAVE_ACCOUNT_NAME: "saveAccountName",
    SAVE_INSURANCE_ACCOUNT_DETAILS: "saveInsuranceAccountDetails",
    SAVE_BILL_TO_ACCOUNT_NUMBER: "saveBillToAccountNumber",
    SAVE_SUPPORTING_ITEMS: "saveSupportingItems",
    SAVE_SUPPORTING_ITEMS_SUPPRESSING_STATE_RESETTING:
        "saveSupportingItemsSuppressingStateResetting",
    SAVE_VAPS: "saveVaps",
    SAVE_ACTIVE_AND_OR_INACTIVE_PROMOS: "saveActiveAndOrInactivePromos",
    SAVE_CUSTOMER_DETAILS: "saveCustomerDetails",
    SAVE_INSURANCE_DETAILS: "saveInsuranceDetails",
    SAVE_DAMAGE_DETAILS: "saveDamageDetails",
    SAVE_VERIFY_DETAILS: "saveVerifyDetails",
    SAVE_SERVICE_LOCATION_TECH_NOTES: "saveServiceLocationTechNotes",
    SAVE_CCTOKEN: "saveCCToken",
    SAVE_PAYPAL_TOKEN: "savePaypalToken",
    SAVE_NEXTGEN_SETTLED_AMOUNT: "saveNextGenSettledAmount",
    SAVE_AUTHORIZATION_AMOUNT: "saveAuthorizationAmount",
    SAVE_IS_RECAL_ACK_OPT_IN: "saveIsRecalAckOptIn",
    SAVE_IS_RECAL_ACKNOWLEDGED_FOR_SCHEDULING: "saveIsRecalAcknowledgedForScheduling",
    SAVE_IS_OEM_GLASS_SELECTED: "saveIsOemGlassSelected",
    SAVE_IS_MSR_FEE_APPLICABLE: "saveIsMSRFeeApplicable",
    SAVE_IS_MSR_FEE_COVERED_BY_INSURANCE: "saveIsMSRFeeCoveredByInsurance",
    SAVE_IS_NEW_INSURANCE_FLOW: "saveIsNewInsuranceFlow",
    SAVE_DUPLICATE_ORDERS: "saveDuplicateOrders",
    SAVE_SUBMIT_TO_MAINFRAME: "saveSubmitToMainframe",

    CREATE_SUBMITTED_STATE: "createSubmittedState",
    RESET_SUBMITTED_STATE: "resetSubmittedState",
    RESET_INSURANCE_DETAILS: "resetInsuranceDetails",
    ADD_DONATION_TO_SUBMITTED_STATE: "addDonationToSubmittedState",
    RESET_EXTERNAL_PARAMETER_STATE: "resetExternalParameterState",
    UPDATE_EXTERNAL_PARAMETER_MMS: "updateExternalParameterMMS",

    SAVE_LOGGING_OPTION: "saveLoggingOption",
    UPDATE_HAS_TRIGGERED_ERROR: "updateHasTriggeredError",
    GET_VALID_IDEMPOTENCY_KEY: "getValidIdempotencyKey",
    CORRECT_IDEMPOTENCY_KEY_EXPIRY: "correctIdempotencyKeyExpiry",
};

export { storeActions };
